import { render, staticRenderFns } from "./EmailBodySettings.vue?vue&type=template&id=2b79ff9a&scoped=true&"
import script from "./EmailBodySettings.vue?vue&type=script&lang=js&"
export * from "./EmailBodySettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailBodySettings.vue?vue&type=style&index=0&id=2b79ff9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79ff9a",
  null
  
)

export default component.exports